import PropTypes from 'prop-types'

import { idPropType } from '../../common/prop-types'

const alternativeIngredientPropType = PropTypes.shape({
  alternativeIngredientId: idPropType.isRequired,
  dietId: idPropType.isRequired,
})

export default alternativeIngredientPropType
